import React, { forwardRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { InstrumentationOptions } from 'types';
import { checkIfAbsoluteUrl } from 'utils/url';

// export interface RouterButtonProps extends ButtonProps, RouteComponentProps {
export interface RouterLinkProps {
    instrumentationOptions?: InstrumentationOptions;
    to?: string;
    onClick?: (event: React.MouseEvent) => void;
    isDisabled?: boolean;
    isDropdown?: boolean;
    isFull?: boolean;
    isLoading?: boolean;
    isRounded?: boolean;
    hasFocusOutline?: boolean;
    isNav?: boolean;
    children?: React.ReactNode;
    exact?: boolean;
    target?: string;
}

export const RouterLink = forwardRef(
    (
        {
            instrumentationOptions,
            to,
            onClick,
            isDisabled,
            isDropdown,
            isFull,
            isLoading,
            isRounded,
            hasFocusOutline,
            isNav,
            exact,
            target = '_blank',
            ...props
        }: RouterLinkProps,
        ref: React.Ref<HTMLAnchorElement>,
    ) => {
        const handleOnClick = (
            event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        ) => {
            onClick && onClick(event);
        };

        if (!to) {
            return <>{props.children}</>;
        }

        const isAbsoluteUrl = checkIfAbsoluteUrl(to);

        // Fallback for absolute url
        if (isAbsoluteUrl) {
            return (
                <a
                    href={to}
                    onClick={handleOnClick}
                    ref={ref}
                    target={target}
                    rel="noopener noreferrer"
                    {...props}
                >
                    {props.children}
                </a>
            );
        }

        return isNav ? (
            <NavLink to={to} onClick={handleOnClick} ref={ref} {...props}>
                {props.children}
            </NavLink>
        ) : (
            <Link to={to} onClick={handleOnClick} ref={ref} {...props}>
                {props.children}
            </Link>
        );
    },
);

export default RouterLink;
